import React from 'react';
import { CreditCard, Eye, Zap, Banknote, CheckCircle } from 'lucide-react';

const SmarterPaymentSetup = () => {
  const terminalImage = "https://customer-assets.emergentagent.com/job_hvacpro-support/artifacts/hgi5f0zf_3667.jpg";

  const features = [
    { icon: CreditCard, text: "Save cards for repeat customers" },
    { icon: Eye, text: "Real-time transaction visibility" },
    { icon: Zap, text: "Faster, smoother checkout" },
    { icon: Banknote, text: "Accept Cards + ACH" }
  ];

  return (
    <section className="py-20" style={{ backgroundColor: '#F8FAFC' }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" style={{ color: '#0F172A' }}>
          A Smarter <span style={{ color: '#D4AF37' }}>Payment System</span>
        </h2>
        
        {/* Single Terminal Image - cropped to device only */}
        <div className="max-w-sm mx-auto mb-10">
          <div className="rounded-2xl overflow-hidden shadow-xl bg-gray-900">
            <img 
              src={terminalImage}
              alt="Stackably payment system"
              className="w-full"
              style={{ objectFit: 'cover', objectPosition: 'center 100%', height: '280px' }}
              data-testid="terminal-image"
            />
          </div>
        </div>
        
        {/* Description */}
        <p className="text-xl text-center text-gray-600 mb-10 max-w-3xl mx-auto">
          Modern terminals simplify payments, improve operations, and support repeat clients with our partner <span className="font-semibold" style={{ color: '#D4AF37' }}>Stackably</span>.
        </p>
        
        {/* Features List */}
        <div className="grid md:grid-cols-2 gap-4 max-w-3xl mx-auto mb-10">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <div 
                key={index}
                className="flex items-center gap-3 bg-white rounded-xl px-5 py-4 shadow-md border border-gray-100"
              >
                <div 
                  className="w-10 h-10 rounded-lg flex items-center justify-center"
                  style={{ backgroundColor: 'rgba(212, 175, 55, 0.1)' }}
                >
                  <IconComponent style={{ color: '#D4AF37' }} size={20} />
                </div>
                <span className="font-medium" style={{ color: '#0F172A' }}>{feature.text}</span>
              </div>
            );
          })}
        </div>
        
        {/* Bottom Note */}
        <div className="text-center">
          <div className="inline-flex items-center gap-2 px-6 py-3 rounded-full" style={{ backgroundColor: 'rgba(34, 197, 94, 0.1)' }}>
            <CheckCircle style={{ color: '#22C55E' }} size={20} />
            <span className="font-semibold" style={{ color: '#22C55E' }}>
              Fully set up for you — no hassle, no disruption.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SmarterPaymentSetup;
